import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.whatsnewforme.title',
    defaultMessage: 'WHAT’S NEW FOR ME?',
  },
  noUpgrades: {
    id: 'pages.whatsnewforme.noUpgrades',
    defaultMessage: 'You have no product upgrades available.',
  },
  productsIncluded: {
    id: 'pages.whatsnewforme.productsIncluded',
    defaultMessage: 'See what {productsIncludedLink} in the full version.',
  },
  productsIncludedLink: {
    id: 'pages.whatsnewforme.productsIncludedLink',
    defaultMessage: 'products are included',
  },
  newCustomers: {
    id: 'pages.whatsnewforme.newCustomers',
    defaultMessage: 'For new customers',
  },
  owners: {
    id: 'pages.whatsnewforme.owners',
    defaultMessage: 'For owners of {product}',
  },
  youSave: {
    id: 'pages.whatsnewforme.youSave',
    defaultMessage: 'You save',
  },
  youllGet: {
    id: 'pages.whatsnewforme.youllGet',
    defaultMessage: `Products you'll get`,
  },
  getProductButton: {
    id: 'pages.whatsnewforme.getProductButton',
    defaultMessage: 'Get {product}',
  },
  getProductNowButton: {
    id: 'pages.whatsnewforme.getProductNowButton',
    defaultMessage: 'Get {product} now',
  },
  showMoreProducts: {
    id: 'common.button.showMoreProducts',
    defaultMessage: 'Show more products',
  },
  ownPrevious: {
    id: 'pages.whatsnewforme.ownPrevious',
    defaultMessage: 'Own a previous version of this product?',
  },
  ownPreviousButton: {
    id: 'pages.whatsnewforme.ownPreviousButton',
    defaultMessage: 'Login for Update/upgrade options',
  },
});
